import httpClient from '@/app/utils/axios';

export function updateStudentFocus(classroomId: number, status: 'focus' | 'blur') {
    return httpClient.post(route('app.student.focus'), {
        classroom_id: classroomId,
        status,
    });
}
